import React from 'react';

import { Table, Input, Select } from 'antd';
import { FilterOutlined, SearchOutlined } from '@ant-design/icons';
import { TableSearchPanel } from 'ui/TableSearchPanel';
import { checkValue } from 'utils';
import { PAGE_SIZE_OPTIONS, SCROLL_Y } from 'constants/table';
import { renderWithTooltip } from 'utils/table';

function StoriesTable({
  items,
  current,
  pageSize,
  storyGroups,
  loading,
  totalRows,
  onRowClick,
  onGroupFilter,
  onChange,
}) {
  const columns = [
    {
      title: 'Заголовок',
      dataIndex: 'title',
      key: 'title',
      render: (value) => renderWithTooltip(value),
      filterDropdown: ({ selectedKeys, setSelectedKeys, confirm }) => {
        return (
          <TableSearchPanel>
            <Input
              autoFocus
              placeholder="Поиск по заголовоку"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onPressEnter={() => confirm()}
            />
          </TableSearchPanel>
        );
      },
      filterIcon: () => <SearchOutlined />,
      onFilter: (value, record) => {
        return record?.title.toLowerCase().includes(value.toLowerCase());
      },
    },
    {
      title: 'Описание',
      dataIndex: 'description',
      key: 'description',
      render: (value) => renderWithTooltip(value),
      filterDropdown: ({ selectedKeys, setSelectedKeys, confirm }) => {
        return (
          <TableSearchPanel>
            <Input
              autoFocus
              placeholder="Поиск по заголовоку"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onPressEnter={() => confirm()}
            />
          </TableSearchPanel>
        );
      },
      filterIcon: () => <SearchOutlined />,
      onFilter: (value, record) => {
        return record?.description.toLowerCase().includes(value.toLowerCase());
      },
    },
    {
      title: 'Медиа',
      dataIndex: 'image',
      key: 'image',
      render: (value) => {
        if (value) {
          return (
            <a
              href={`${process.env.REACT_APP_HOSTNAME}/api/media/${value}/`}
              target="blank"
              onClick={(e) => e.stopPropagation()}
            >
              {value}
            </a>
          );
        }

        return checkValue(value);
      },
    },
    {
      title: 'Медиа (каз)',
      dataIndex: 'image_kz',
      key: 'image_kz',
      render: (value) => {
        if (value) {
          return (
            <a
              href={`${process.env.REACT_APP_HOSTNAME}/api/media/${value}/`}
              target="blank"
              onClick={(e) => e.stopPropagation()}
            >
              {value}
            </a>
          );
        }

        return checkValue(value);
      },
    },
    {
      title: 'Группа истории',
      dataIndex: 'story_group_id',
      key: 'story_group_id',
      render: (value) => {
        return renderWithTooltip(
          storyGroups?.find((group) => group.id === value)?.title
        );
      },
      filterDropdown: ({ confirm }) => {
        return (
          <TableSearchPanel>
            <Select
              style={{ width: '260px' }}
              placeholder="Группа"
              allowClear
              showSearch
              optionFilterProp="children"
              onChange={(groupId) => {
                onGroupFilter(groupId);
                confirm();
              }}
            >
              {storyGroups.map(({ id, title }) => (
                <Select.Option key={id} value={id}>
                  {title}
                </Select.Option>
              ))}
            </Select>
          </TableSearchPanel>
        );
      },
      filterIcon: () => <FilterOutlined />,
    },
    {
      title: ' Порядок',
      dataIndex: 'position',
      key: 'position',
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={items}
      loading={loading}
      pagination={{
        current,
        pageSize,
        total: totalRows,
        showSizeChanger: true,
        pageSizeOptions: PAGE_SIZE_OPTIONS,
      }}
      rowKey="id"
      scroll={{ x: 1200, y: SCROLL_Y }}
      onRow={(record) => {
        return {
          onDoubleClick: () => onRowClick(record),
        };
      }}
      onChange={onChange}
    />
  );
}

export { StoriesTable };
